import dayjs from "dayjs";

export const formatProductionExpenseAmount = (value) =>
  `${Number(value || 0).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} CFA`;

export function getProductionExpenseDefaults(production, cost) {
  const date = dayjs(production.created_at);
  const expenseDate = date.isValid() ? date : dayjs();
  const reference = production.production_code || production.lot_code;
  const source = [production.production_unit_name, reference].filter(Boolean).join(" — ");
  const quantity = Number(cost.output_quantity);
  const rate = Number(cost.cost_per_unit);
  const calculation = quantity > 0 && Number.isFinite(rate)
    ? ` ${quantity.toLocaleString("fr-FR", { maximumFractionDigits: 6 })} unité(s) × ${rate.toLocaleString("fr-FR", { maximumFractionDigits: 6 })} CFA.` : "";
  const notes = `Régularisation du coût variable « ${cost.label} » de la production${source ? ` ${source}` : ""} du ${expenseDate.format("DD/MM/YYYY")}.${calculation} Montant constaté : ${formatProductionExpenseAmount(cost.total_cost)}.`;
  return {
    supplier_id: Number(cost.suggested_supplier_id || cost.supplier_id) || undefined,
    expense_category_id: Number(cost.suggested_expense_category_id || cost.expense_category_id) || undefined,
    expense_date: expenseDate,
    due_date: expenseDate,
    bill: "",
    notes,
    add_payment: false,
    payment_date: dayjs(),
    payment_amount: Number(cost.total_cost),
    payment_notes: `Règlement du coût variable « ${cost.label} »${reference ? ` — production ${reference}` : ""}.`,
  };
}

export function buildProductionExpensePayload(values, { companyId, warehouseId, document, canPay }) {
  return {
    company_id: companyId,
    warehouse_id: warehouseId,
    supplier_id: values.supplier_id,
    expense_category_id: values.expense_category_id,
    expense_date: values.expense_date.format("YYYY-MM-DD"),
    due_date: values.due_date?.format("YYYY-MM-DD") || null,
    bill: values.bill?.trim() || null,
    notes: values.notes?.trim() || null,
    document_url: document?.url || null,
    document_name: document?.originalName || null,
    // Never submit hidden payment values after disabling the payment section.
    payment: canPay && values.supplier_id && values.add_payment ? {
      amount: values.payment_amount,
      date: values.payment_date.format("YYYY-MM-DD"),
      payment_mode_id: values.payment_mode_id,
      treasury_account_id: values.treasury_account_id,
      notes: values.payment_notes?.trim() || "",
    } : null,
  };
}
